import classNames from "classnames";
import React from "react";

interface IParams {
  badgeColor?: string;
}

const ExistingNoteIcon: React.FC<IParams> = ({ badgeColor }) => {
  return (
    <>
      <div
        className="existing-note-icon-common existing-note-icon-outer"
        style={{
          position: "absolute",
          top: 0,
          left: "70%",
          width: 24,
          height: 24,
          backgroundColor: "black",
          borderRadius: 50,
        }}
      >
        <div
          className={classNames(
            "existing-note-icon-common existing-note-icon-inner bg-red",
            badgeColor ? `bg-${badgeColor}` : "bg-red"
          )}
        ></div>
      </div>
    </>
  );
};

export default ExistingNoteIcon;
